import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateFormatter, infoFormatterIntl } from '../../../../utils/formatters';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function OsgopInsuranceView({
  data = {}, labelPrefix = '', hideSeries = false, formMeta, prefix = '', currentApplication = {},
}) {
  const {
    insurer = '',
    insurance_contract_series = '',
    insurance_contract_number = '',
    insurance_contract_effective_date = '',
    insurance_contract_expiration_date = '',
  } = data || {};

  const { files = [] } = currentApplication;

  const osgop_files = files && files.length ? files.find(item => item.collection_name === 'osgop_files') : undefined;

  return (
    <>
      <Row className="row-cols-3">
        {infoFormatterIntl(`${labelPrefix}insurer`, insurer, formMeta, `${prefix}insurer`)}
        {infoFormatterIntl(`${labelPrefix}insurance_contract_number`, insurance_contract_number, formMeta, `${prefix}insurance_contract_number`)}
        {infoFormatterIntl(`${labelPrefix}insurance_contract_effective_date`, dateFormatter(insurance_contract_effective_date), formMeta, `${prefix}insurance_contract_effective_date`)}
      </Row>
      <Row className="row-cols-3">
        {infoFormatterIntl(`${labelPrefix}insurance_contract_expiration_date`, dateFormatter(insurance_contract_expiration_date), formMeta, `${prefix}insurance_contract_expiration_date`)}
        {infoFormatterIntl(
          'media.osgop_files',
          osgop_files ? (
            <FileView
              readOnly
              withoutMime
              withoutHr
              files={[osgop_files]}
            />
          ) : null,
          formMeta,
          '',
          4,
        )}
      </Row>
    </>
  );
}
